import * as React from "react";
import { forwardRef } from "react";
const SvgCarouselActiveDot = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 17, viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { y: 4, width: 16, height: 8, rx: 4, fill: "#8F8F8F" }));
const ForwardRef = forwardRef(SvgCarouselActiveDot);
export { ForwardRef as ReactComponent };
